const envConfig = {
  REACT_APP_API_TOKEN: process.env.REACT_APP_API_TOKEN ?? 'bf31a99cfe2f48a8a8f378ff284911fa',
  REACT_APP_API_URL: process.env.REACT_APP_API_URL ?? 'https://airbnb-concierge-grocefy.azure-api.net/admin',
  REACT_APP_DEFAULT_API_URL: process.env.REACT_APP_API_URL ?? 'https://airbnb-concierge-grocefy.azure-api.net/admin',
  REACT_APP_CLIENT_ID: process.env.REACT_APP_CLIENT_ID ?? 'bf31a99cfe2f48a8a8f378ff284911fa',
  REACT_APP_HUB_URL: process.env.REACT_APP_HUB_URL ?? 'https://airbnb-concierge-api-prod.azurewebsites.net/',
  REACT_APP_GEO_API_KEY: process.env.REACT_APP_GEO_API_KEY ?? 'AIzaSyCbyH9QdelpvTas84vne4P4dffXrGXjVtE',
  REACT_APP_PREFIX: process.env.REACT_APP_PREFIX ?? 'grocefy-concierge',

  REACT_APP_DEFAULT_LANGUAGE: process.env.REACT_APP_DEFAULT_LANGUAGE ?? '#{REACT_APP_DEFAULT_LANGUAGE}#',

  REACT_APP_IMAGES_URL: process.env.REACT_APP_IMAGES_URL ?? 'https://grocefy-dev.azure-api.net/images/',
  REACT_APP_IMAGES_KEY: process.env.REACT_APP_IMAGES_KEY ?? '1043159d43f1465bba872d74fe9b6a4e',
  REACT_APP_UTILITY_KEY: process.env.REACT_APP_UTILITY_KEY ?? 'en',
  REACT_APP_PAYMENTS_KEY: process.env.REACT_APP_PAYMENTS_KEY ?? '9f09ee1311b041afad4a09b53bce41022e952f1576be4933b63a3af9e1860745bf6642961a6e45aba8f05363ca875473c6a4b854e1ab40e19c79b033b3f5a17e',
  REACT_APP_BOOKING_API_URL: process.env.REACT_APP_BOOKING_API_URL ?? '#{REACT_APP_BOOKING_API_URL}#',
  REACT_APP_BOOKING_API_KEY: process.env.REACT_APP_BOOKING_API_KEY ?? '#{REACT_APP_BOOKING_API_KEY}#',
  REACT_APP_TIMEZONE_OFFSET: process.env.REACT_APP_TIMEZONE_OFFSET ?? '-4',
  REACT_APP_BOOKING_CANCELLATION_FEE: process.env.REACT_APP_BOOKING_CANCELLATION_FEE ?? '15',
  BookingEventUrl: process.env.REACT_APP_BOOKING_API_EVENT_URL ?? '#{REACT_APP_BOOKING_API_EVENT_URL}#',
  SpecificProductUrl: process.env.REACT_APP_SPECIFIC_PRODUCT_URL ?? '#{REACT_APP_SPECIFIC_PRODUCT_URL}#',
  WebsiteUrl: process.env.REACT_APP_WEBSITE_URL ?? '#{REACT_APP_WEBSITE_URL}#',

  TimesheetHourlyRate: process.env.REACT_APP_TIMESHEET_HOURLY_RATE?.toString() ?? '#{REACT_APP_TIMESHEET_HOURLY_RATE}#',
  TimesheetDeductionRate: process.env.REACT_APP_TIMESHEET_DEDUCTION_RATE?.toString() ?? '#{REACT_APP_TIMESHEET_DEDUCTION_RATE}#'
};

export default envConfig;
